import vue from "vue";
export const contactEnquiry = async (payload) =>
  await vue.axios.post("/cms/contact-enquiry/create", payload);
